/* eslint-disable no-unused-vars */
import * as S from './WelcomeManageCampaigns.styled';
import { Buttons } from 'components';
import { ManageCampaignsWelcome, Plus } from 'assets/icons';
import { routes } from 'config';
import { useNavigate } from 'react-router-dom';

export const WelcomeManageCampaigns = () => {
  const navigate = useNavigate();

  const goToCreateCampaign = () => {
    let url = routes.list.find((route) => route.id === 'campaign/newCampaign_empty').url;
    navigate(url);
  };

  return (
    <S.Container>
      <S.Title>Welcome</S.Title>
      <S.Text>
        Get started by creating your first campaign. We&apos;ll walk you through the process, and
        <br />
        you&apos;ll have all the settings you need to reach success.
      </S.Text>
      <Buttons.PrimaryNormal
        icon={<Plus />}
        id='createCampaign'
        onClick={() => goToCreateCampaign()}
      >
        Create Campaign
      </Buttons.PrimaryNormal>
      <ManageCampaignsWelcome />
    </S.Container>
  );
};
